import React from "react";
import { BrowserRouter } from "react-router-dom";
import { Provider } from "react-redux";
import { createStore, combineReducers, applyMiddleware, compose } from "redux";
import thunk from "redux-thunk";
import { ApolloProvider } from "react-apollo";
import * as Sentry from "@sentry/browser";

import App from "../components/App";
import * as reducers from "../store/reducers";
import client from "../apollo";

if (process.env.NODE_ENV !== "development") {
  Sentry.init({
    dsn: "https://2d8124fc671c45caa52e34d93454a611@sentry.io/170129"
  });
}

const store = createStore(
  combineReducers(reducers),
  window.SERVER_STATE,
  compose(applyMiddleware(client.middleware(), thunk))
);

// We need a Root component for React Hot Loading.
export default () => (
  <BrowserRouter>
    <ApolloProvider store={store} client={client}>
      <App />
    </ApolloProvider>
  </BrowserRouter>
);



// WEBPACK FOOTER //
// /src/client/Root.js